// React
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// @mui material components
import { Card, Fade, Icon, Modal, Tooltip, InputLabel, Slide } from "@mui/material";

import { gql, useLazyQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { formatMoneyPunto } from "utils/formatters";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { makeNiceText } from "utils/formatters";
import SoftBadge from "components/SoftBadge";
import dayjs from "dayjs";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "95%",
    minHeight: "40%",
    width: { xs: "90%", sm: "80%", xxl: "70%" },
    overflowY: "auto",
};

const GET_REPORTE = gql`
  query reporteConsumoInterno($fechaInicio: Date!, $fechaFin: Date!) {
    reporteConsumoInterno(fechaInicio: $fechaInicio, fechaFin: $fechaFin) {
      empleado {
        id
        nombre
        apellido
        dni
      }
      consumos {
        id
        idPedidoDetalleInterno
        pedidoDetalleInterno {
          id
        }
        idProducto
        producto {
          id
          nombre
          precioCarta
        }
        estado
        precio
        precioEditado
        cantidad
        esElaborado
        costo
        motivoCancelacion
        comentario
        createdAt
      }
      total
    }
  }
`;

export default function ModalReporteConsumoInterno({ open, handleClose }) {
    const [fecha, setFecha] = useState();
    const [fechaInicio, setFechaInicio] = useState();
    const [fechaFin, setFechaFin] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [getReporte, { data, loading, error }] = useLazyQuery(GET_REPORTE, {
        cachePolicy: "no-cache",
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        setFechaInicio(null);
        setFechaFin(null);
        setSelectedItem(null);
    }, [])

    const exportToExcel = (data) => {
        if (!data) return;

        const excelData = data.reporteCuentaCorriente.map((item) => ({
            Cliente: `${item.cliente.nombre} ${item.cliente.apellido}`,
            DNI: item.cliente.dni,
            Total: item.total,
        }));

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");

        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileName = `ReporteCuentaCorriente_${fecha}.xlsx`;
        saveAs(blob, fileName);
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
        >
            <Fade in={open}>
                <Card sx={style}>
                    <SoftBox>
                        <SoftBox display="flex" justifyContent="space-between" p={3}>
                            <SoftBox>
                                <SoftTypography variant="h6">Reporte de consumo interno</SoftTypography>
                            </SoftBox>

                            <SoftBox display="flex" justifyContent="flex-end">
                                <SoftBox display="flex" alignItems="center">
                                    <Tooltip title="Cerrar" placement="top">
                                        <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                                            close
                                        </Icon>
                                    </Tooltip>
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>

                        <SoftBox display="flex" alignItems='center' gap={1} py={3} pl={3} pr={3}>
                            <SoftBox width="100%">
                                <InputLabel htmlFor="fechaInicio">
                                    <SoftTypography variant="caption">Fecha Inicio</SoftTypography>
                                </InputLabel>
                                <SoftInput
                                    type="date"
                                    id="fechaInicio"
                                    value={fechaInicio}
                                    onChange={(e) => setFechaInicio(e.target.value)}
                                    fullWidth
                                />
                            </SoftBox>
                            <SoftBox width="100%">
                                <InputLabel htmlFor="fechaFin">
                                    <SoftTypography variant="caption">Fecha Fin</SoftTypography>
                                </InputLabel>
                                <SoftInput
                                    type="date"
                                    id="fechaFin"
                                    value={fechaFin}
                                    onChange={(e) => setFechaFin(e.target.value)}
                                    fullWidth
                                />
                            </SoftBox>
                            <SoftBox sx={{ mt: 3.5 }}>
                                <SoftButton
                                    color="primary"
                                    onClick={() => {
                                        getReporte({
                                            variables: { fechaInicio, fechaFin },
                                        });
                                        setSelectedItem();
                                    }}
                                    disabled={!fechaInicio || !fechaFin}
                                >
                                    <Icon>search</Icon>
                                    &nbsp;Generar
                                </SoftButton>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                    <SoftBox
                        sx={{
                            maxHeight: "50vh",
                        }}
                    >
                        {loading ? (
                            <Loading />
                        ) : data && (data?.reporteConsumoInterno || []).length > 0 ? (
                            <SoftBox
                                gap={2}
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    gap: "1rem",
                                }}
                            >
                                {console.log('sel....', selectedItem)}
                                <Slide direction="right" in={true} mountOnEnter unmountOnExit>
                                    <SoftBox
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            transition: "all 0.5s",
                                        }}
                                    >
                                        <SoftBox
                                            sx={{
                                                maxHeight: "60vh",
                                                overflow: "auto",
                                                width: "100%",
                                                p: 2,
                                            }}
                                        >
                                            <SoftBox
                                                display="flex"
                                                justifyContent="space-between"
                                                sx={{ padding: 1, fontWeight: "bold" }}
                                            >
                                                <SoftTypography
                                                    variant="h6"
                                                    sx={{ flex: 1, minWidth: "33%", textAlign: "left" }}
                                                >
                                                    Empleado
                                                </SoftTypography>
                                                <SoftTypography
                                                    variant="h6"
                                                    sx={{ flex: 1, minWidth: "33%", textAlign: "center" }}
                                                >
                                                    DNI
                                                </SoftTypography>
                                                <SoftTypography
                                                    variant="h6"
                                                    sx={{ flex: 1, minWidth: "33%", textAlign: "right" }}
                                                >
                                                    Total
                                                </SoftTypography>
                                            </SoftBox>
                                            {(data?.reporteConsumoInterno || []).map((item, index) => (
                                                <SoftBox
                                                    key={index}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    sx={{
                                                        backgroundColor:
                                                            selectedItem && selectedItem?.empleado?.id === item?.empleado?.id
                                                                ? getUproColor("uproYellow")
                                                                : "white",
                                                        cursor: "pointer",
                                                        border:
                                                            selectedItem && selectedItem?.empleado?.id === item?.empleado?.id
                                                                ? 1
                                                                : 0,
                                                        borderRadius: 1,
                                                        padding: 1,
                                                        marginTop: 1,
                                                        "&:hover": {
                                                            backgroundColor: getUproColor("uproYellow"),
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        if (selectedItem && selectedItem?.empleado?.id === item?.empleado?.id) {
                                                            setSelectedItem();
                                                            return;
                                                        }
                                                        setSelectedItem(item);
                                                    }}
                                                >
                                                    <SoftTypography
                                                        variant="button"
                                                        sx={{ flex: 1, minWidth: "33%", textAlign: "left" }}
                                                    >
                                                        {item.empleado.nombre
                                                            ? makeNiceText(item.empleado.nombre)
                                                            : item.empleado.nombre}{" "}
                                                        {item.empleado.apellido
                                                            ? makeNiceText(item.empleado.apellido)
                                                            : item.empleado.apellido}
                                                    </SoftTypography>
                                                    <SoftTypography
                                                        variant="button"
                                                        sx={{ flex: 1, minWidth: "33%", textAlign: "center" }}
                                                    >
                                                        {item.empleado.dni ? item.empleado.dni : "Sin especificar"}
                                                    </SoftTypography>
                                                    <SoftTypography
                                                        variant="button"
                                                        sx={{ flex: 1, minWidth: "33%", textAlign: "right" }}
                                                    >
                                                        $ {item.total ? formatMoneyPunto(item.total) : 0}
                                                    </SoftTypography>
                                                </SoftBox>
                                            ))}
                                        </SoftBox>
                                    </SoftBox>
                                </Slide>
                                <Slide direction="left" in={selectedItem} mountOnEnter unmountOnExit>
                                    <SoftBox
                                        sx={{
                                            width: {
                                                xs: "100%",
                                                sm: "40%",
                                            },
                                            display: {
                                                xs: "none",
                                                sm: "flex",
                                            },
                                        }}
                                    >
                                        <SoftBox
                                            sx={{
                                                maxHeight: "60vh",
                                                overflow: "auto",
                                                width: "100%",
                                                p: 2,
                                            }}
                                        >
                                            {selectedItem && (
                                                <SoftBox display="flex" flexDirection="column" gap={2}>
                                                    {(selectedItem.consumos || []).map((consumo) => {
                                                        return (
                                                            <Card
                                                                key={consumo.id}
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid rgba(0, 0, 0, 0.12)",
                                                                    "&:hover": {
                                                                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                                                                    },
                                                                }}
                                                            >
                                                                <SoftBox
                                                                    p={2}
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    gap={2}
                                                                >
                                                                    <SoftBox
                                                                        display="flex"
                                                                        justifyContent="space-between"
                                                                        alignItems="center"
                                                                    >
                                                                        <SoftBox
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            gap={1}
                                                                            sx={{
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <SoftBadge
                                                                                container
                                                                                variant="color"
                                                                                color={getUproColor("uproYellow")}
                                                                                badgeContent={consumo?.producto?.nombre}
                                                                            />
                                                                        </SoftBox>
                                                                    </SoftBox>
                                                                    <SoftBox display="flex" alignItems="center" gap={2}>
                                                                        <SoftBox display="flex" alignItems="center" gap={1}>
                                                                            <Icon color="primary" fontSize="small">
                                                                                calendar_today
                                                                            </Icon>
                                                                            <SoftTypography variant="subtitle2" fontWeight="bold">
                                                                                {dayjs(consumo.createdAt).format("DD/MM/YYYY")}
                                                                            </SoftTypography>
                                                                        </SoftBox>
                                                                        <SoftBox display="flex" alignItems="center">
                                                                            {consumo?.precioEditado !== 0 && <Icon color="primary" fontSize="small">
                                                                                attach_money
                                                                            </Icon>}
                                                                            <SoftTypography variant="subtitle2" fontWeight="bold" color={consumo?.precioEditado === 0 ? "primary" : "dark"}>
                                                                                {consumo?.precioEditado === 0 ? "Gratis" : formatMoneyPunto(consumo?.precioEditado)}
                                                                            </SoftTypography>
                                                                        </SoftBox>
                                                                    </SoftBox>
                                                                    <SoftBox
                                                                        display="flex"
                                                                        justifyContent="space-between"
                                                                        alignItems="center"
                                                                    >
                                                                        <SoftBox
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            gap={1}
                                                                            sx={{
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <SoftBadge
                                                                                container
                                                                                variant="color"
                                                                                color={'primary'}
                                                                                badgeContent={'Costo'}
                                                                            />
                                                                            <SoftBox display="flex" alignItems="center">
                                                                                <Icon color="primary" fontSize="small">
                                                                                    attach_money
                                                                                </Icon>
                                                                                <SoftTypography variant="subtitle2" alignItems="center" fontWeight="bold">
                                                                                    {formatMoneyPunto(consumo?.producto?.precioCarta)}
                                                                                </SoftTypography>
                                                                            </SoftBox>

                                                                        </SoftBox>
                                                                    </SoftBox>
                                                                    {/* {consumo?.producto?.precioCarta !== consumo?.precioEditado && (
                                                                        <SoftBox display="flex" alignItems="center">
                                                                            <Icon color="primary" fontSize="small">
                                                                                edit
                                                                            </Icon>
                                                                            <SoftTypography variant="subtitle2" mx={1} alignItems="center" fontWeight="bold">
                                                                                Editado
                                                                            </SoftTypography>
                                                                            <Icon color="primary" fontSize="small">
                                                                                attach_money
                                                                            </Icon>
                                                                            <SoftTypography variant="subtitle2" alignItems="center" fontWeight="bold">
                                                                                {formatMoneyPunto(consumo?.producto?.precioCarta)}
                                                                            </SoftTypography>
                                                                        </SoftBox>
                                                                    )} */}
                                                                </SoftBox>
                                                            </Card>
                                                        );
                                                    })}
                                                </SoftBox>
                                            )}
                                        </SoftBox>
                                    </SoftBox>
                                </Slide>
                                <Slide direction="left" in={!selectedItem} mountOnEnter unmountOnExit>
                                    <SoftBox
                                        sx={{
                                            width: {
                                                xs: "100%",
                                                sm: "40%",
                                            },
                                            display: {
                                                xs: "none",
                                                sm: "flex",
                                            },
                                        }}
                                    >
                                        <SinDatos
                                            titulo="Seleccione un empleado"
                                            mensaje="para ver los detalles"
                                            icono="emoji_people"
                                        />
                                    </SoftBox>
                                </Slide>
                            </SoftBox>
                        ) : (
                            <SinDatos />
                        )}
                        <SoftBox
                            display="flex"
                            justifyContent="flex-start"
                            p={3}
                            sx={{
                                marginTop: "auto",
                            }}
                        >
                            <SoftTypography variant="h6">
                                Total consumo interno: ${" "}
                                {data && (data.reporteConsumoInterno || []).length > 0
                                    ? formatMoneyPunto(
                                        (data.reporteConsumoInterno || []).reduce((acc, item) => acc + item.total, 0)
                                    )
                                    : 0}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </Card>
            </Fade>
        </Modal>
    );
}

ModalReporteConsumoInterno.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};